<template>
  <div class="clinical">
    <div class="container">
      <div class="title"></div>
      <div class="sub-title">关于COQUN</div>
      <div class="content">
        辅酶Q10，也称为泛醌，是一种存在于所有真核生物物种中的亲脂性分子，可能存在于每个细胞
中。它存在于质膜和其他内膜系统（如线粒体）中。辅酶Q10在线粒体能量学（ATP的产生）中起着
重要作用，是一种有效的抗氧化剂和自由基清除剂，并在调节细胞凋亡中发挥作用。
      </div>
      <div class="item">
        <div class="sub-title">EMGT 研究概述</div>
        <div class="content">
          早期显性青光眼试验 (EMGT) 评估了降低早期、未接受治疗的开角型青光眼眼
压的有效性
<p>试验设计：
这项随机临床试验招募了 255 名年龄在 5O至 8O岁之间、患有早期青光眼视野
缺损且平均眼压为 22 毫米汞柱的新诊断青光眼患者。患者被随机分配接受小
梁成形术加局部盐酸倍他洛尔治疗或不接受初始治疗，并进行密切随访。随
访包括每 3 个月进行一次计算机化视野和眼压测量以及每 6 个月进行一次眼
底照相，平均随访时间为 6 年。</p>
<p>
结果：
平均而言，治疗使眼压降低了 5.1 Hg 或 25%，并且在整个随访过程中保持了降
低。治疗组 (58/129; 45%) 的进展频率低于对照组 (78/126; 62%) (P=O. OO7)，并且
接受治疗的患者发生进展的时间明显较晚。
</p>
结论：
<span
            class="highlight"
          >
            降低眼压有利于青光眼治疗，并可能延缓病情进展。然而，即使眼压正常，大
多数患者最终都会出现一定程度的病情进展。
          </span>
        </div>
      </div>
      <div class="item item2">
        <div class="sub-title">CIGTS 研究概述</div>
        <div class="content">
          协作初始青光眼治疗研究 (CIGTS) 调查了对于新诊断为开角型青光眼（原发性
、色素性或假剥脱性）的患者，局部治疗或小梁切除术是否是初始更好的治
疗方法。
<p>
试验设计：
对 6O7 名患者进行多中心随机临床试验，这些患者接受局部用药（n=3O7）或
小梁切除术（n=3O）以降低眼压。两组均以 6 个月为间隔进行评估，治疗组接
受分阶段用药方案。对患者进行至少 5 年的监测。
</p>
结果：
<span class="highlight">
            小梁切除术和局部治疗均能显著降低眼压。尽管眼压随时间持续降低，但部分患者的视野丧失逐渐加重，占受试者的比例增加到20%以上。
          </span>
        </div>
      </div>
      <div class="item item2">
        <div class="sub-title">NTGS 研究概述</div>
        <div class="content">
          正常眼压性青光眼研究 (NTGS) 旨在阐明当眼压处于统计学正常范围
内时，眼压是否与青光眼视神经损伤的产生有关。
<p>
试验设计：
145 名正常眼压性青光眼受试者中的一只符合条件的眼睛被随机分
配接受不治疗 (n=79，对照组) 或眼压从基线降低 3O% (n=66)。生存
率分析比较了从基线到 5 年的进展时间
</p>
结果：
<p>
在研究中，降压对照组和未治疗对照组中，视野进展发生率相同 (P
=O.21)。然而，在对白内障影响视力的数据进行审查时，未治疗组
(21/79) 的视野进展明显多于治疗组 (8/66)
</p>
结论：
<span class="highlight">
            正常眼压性青光眼患者的视野丧失随着眼压降低而减缓。
然而，尽管眼压降低，仍有一部分患者出现进展
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClinicalTrial",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {};
  },
  created() {},
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.clinical {
  background-color: rgb(72, 173, 241);
  padding: 15px 20px;
  overflow: auto;
  .container {
    height: 100%;
    background-image: url("../../../../assets/moblie/images/clinicbg.png");
    background-size: 100%;
    padding: 15px 15px;
    .title {
      width: 80%;
      height: 1.5rem;
      background-image: url("../../../../assets/moblie/images/clinictitle.png");
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .sub-title {
      background-color: rgb(46, 119, 196);
      color: #fff;
      font-size: 0.4rem;
      font-weight: 700;
      padding: 5px 20px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      width: 3.2rem;
      box-sizing: border-box;
      position: relative;
      left: -20px;
      margin-top: 0.2rem;
    }
    .content {
      margin-top: 0.2rem;
      font-size: 0.3rem;
      line-height: 0.44rem;
      margin-bottom: 0.2rem;
    }
    .item {
      margin-top: 1.3rem;
      &-image {
        width: 4.2rem;
        height: 3.4rem;
        margin: 0 auto;
        margin-top: 0.2rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .item2 {
      margin-top: 2.3rem;
    }
    .highlight {
      color: rgb(51, 116, 188);
      font-weight: 600;
    }
  }
}
</style>
